<div class="investor-result-popover">
  <p class="title" [ngClass]="font?.size">
    {{ info.title | translate }}
  </p>
  <p class="description" [ngClass]="font?.size">
    {{ info.description | translate }}
  </p>
</div>
